import { Devices } from "../../../../../../styles";
import styled from "styled-components";
import { Card, CardBody } from "reactstrap";

const StyledCard = styled(Card)`
  margin-top: 1.25rem;
  width: 100%;
  @media ${Devices.tablet} {
    width: auto;
  }
`;

const StyledCardBody = styled(CardBody)`
  padding: 1rem 1.25rem;
  @media ${Devices.tablet} {
    padding: 1rem 2rem;
  }
`;

export { StyledCard as Card, StyledCardBody as CardBody };
